import { CMSApiResponse }                     from "framework/http/CMSApiClient";
import { RunContextApp }                      from "framework/RCApp";
import { CreateReco, 
         CreateRecoRequestData, 
         GetRecoForUtility,
         IngestRecos,
         UpdateRecos
       }                                      from "types/apis/recoInterfaces";
import { APIData }                            from "types/cms/frontendTypes";
import { QA_WORKFLOW }                        from "types/cms/frontendTypes";

export const RecoApis = {

  createReco : async (rc : RunContextApp, 
                      utilityDocumentId : string, 
                      reco : CreateRecoRequestData) : Promise<CMSApiResponse<CreateReco.retval>> => {
    
    const resp = await rc.cmsApiClient.post<CreateReco.retval>('/reco/createReco', {
      utilityDocumentId : utilityDocumentId,
      data : reco
    })
    return resp
  },

  updateRecos : async (rc : RunContextApp, 
                       utilityDocumentId : string, 
                       pilotId : string, 
                       recos : Partial<APIData<'api::recommendation.recommendation'>>[]) : Promise<CMSApiResponse<UpdateRecos.retval>> => {

    const resp = await rc.cmsApiClient.post<UpdateRecos.retval>(UpdateRecos.apiEndpoint, {
      utilityDocumentId : utilityDocumentId,
      pilotId : pilotId,
      data : recos
    })
    return resp
  },

  discardDraftRecos : async (rc : RunContextApp, 
                             pilotId : string, 
                             recoDocIds : string[]) : Promise<CMSApiResponse<string[]>> => {

    const resp = await rc.cmsApiClient.post<string[]>(`/reco/discardAllDrafts`, {
      pilotId : pilotId,
      data : recoDocIds
    })
    return resp
  },

  publishRecos : async (rc : RunContextApp, 
                        pilotId : string, 
                        recoDocIds : string[]) : Promise<CMSApiResponse<APIData<'api::recommendation.recommendation'>[]>> => {

    const resp = await rc.cmsApiClient.post<APIData<'api::recommendation.recommendation'>[]>(`/reco/publishAll`, {
      pilotId : pilotId,
      data : recoDocIds
    })
    return resp
  },

  unpublishRecos : async (rc : RunContextApp, 
                          pilotId : string, 
                          recoDocIds : string[]) : Promise<CMSApiResponse<APIData<'api::recommendation.recommendation'>[]>> => {

    const resp = await rc.cmsApiClient.post<APIData<'api::recommendation.recommendation'>[]>(`/reco/unpublishAll`, {
      pilotId : pilotId,
      data : recoDocIds
    })
    return resp
  },

  getRecosForUtility : async (rc : RunContextApp, 
                              utilityDocId : string) : Promise<CMSApiResponse<GetRecoForUtility.retval>> => {
    
    const resp = await rc.cmsApiClient.get<GetRecoForUtility.retval>(`/reco/getRecos?utilityDocumentId=${utilityDocId}`)
    return resp
  },

  uploadTempImage : async (rc: RunContextApp, blob : Blob, fileName : string) => {

    const resp = await rc.cmsApiClient.uploadTempImage(blob, fileName)
    return resp
  },

  ingestRecos : async (rc : RunContextApp, 
                      utilityDocumentId : string, 
                      recos : any[]) : Promise<CMSApiResponse<IngestRecos.retval>> => {
    
    const resp = rc.cmsApiClient.post<IngestRecos.retval>('/reco/ingest', {
      recos,
      utilityDocumentId : utilityDocumentId
    }, true, 10000)

    return resp
  },

  getReviewWorkflow : async (rc : RunContextApp) : Promise<CMSApiResponse<QA_WORKFLOW>> => {
    const resp = await rc.cmsApiClient.get<QA_WORKFLOW>('/reco/getReviewWorkflow')
    return resp
  }

}